/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  WorkshopProblemAdd,
  WorkshopProblemRead,
  WorkshopProblemReorder,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    WorkshopProblemAddFromJSON,
    WorkshopProblemAddToJSON,
    WorkshopProblemReadFromJSON,
    WorkshopProblemReadToJSON,
    WorkshopProblemReorderFromJSON,
    WorkshopProblemReorderToJSON,
} from '../models/index';

export interface AddProblemToWorkshopRequest {
    workshopId: string;
    workshopProblemAdd: WorkshopProblemAdd;
    xOrganizationID?: string | null;
}

export interface GetWorkshopProblemRequest {
    workshopId: string;
    problemId: string;
    xOrganizationID?: string | null;
}

export interface ListWorkshopProblemsRequest {
    workshopId: string;
    xOrganizationID?: string | null;
}

export interface RemoveProblemFromWorkshopRequest {
    workshopId: string;
    problemId: string;
    xOrganizationID?: string | null;
}

export interface ReorderWorkshopProblemsRequest {
    workshopId: string;
    workshopProblemReorder: WorkshopProblemReorder;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class WorkshopProblemsApi extends runtime.BaseAPI {

    /**
     * Add a problem to a workshop.  With an explicit order, later problems shift down by one; otherwise the problem is appended.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor
     * Add problem to workshop
     */
    async addProblemToWorkshopRaw(requestParameters: AddProblemToWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopProblemRead>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling addProblemToWorkshop().'
            );
        }

        if (requestParameters['workshopProblemAdd'] == null) {
            throw new runtime.RequiredError(
                'workshopProblemAdd',
                'Required parameter "workshopProblemAdd" was null or undefined when calling addProblemToWorkshop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/problems`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopProblemAddToJSON(requestParameters['workshopProblemAdd']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopProblemReadFromJSON(jsonValue));
    }

    /**
     * Add a problem to a workshop.  With an explicit order, later problems shift down by one; otherwise the problem is appended.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor
     * Add problem to workshop
     */
    async addProblemToWorkshop(requestParameters: AddProblemToWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopProblemRead> {
        const response = await this.addProblemToWorkshopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific problem from a workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor, OR - Workshop participant
     * Get workshop problem
     */
    async getWorkshopProblemRaw(requestParameters: GetWorkshopProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkshopProblemRead>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling getWorkshopProblem().'
            );
        }

        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling getWorkshopProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/problems/{problem_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))).replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkshopProblemReadFromJSON(jsonValue));
    }

    /**
     * Get a specific problem from a workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor, OR - Workshop participant
     * Get workshop problem
     */
    async getWorkshopProblem(requestParameters: GetWorkshopProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkshopProblemRead> {
        const response = await this.getWorkshopProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all problems assigned to a workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor, OR - Workshop participant
     * List workshop problems
     */
    async listWorkshopProblemsRaw(requestParameters: ListWorkshopProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopProblemRead>>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling listWorkshopProblems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/problems`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopProblemReadFromJSON));
    }

    /**
     * List all problems assigned to a workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor, OR - Workshop participant
     * List workshop problems
     */
    async listWorkshopProblems(requestParameters: ListWorkshopProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopProblemRead>> {
        const response = await this.listWorkshopProblemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a problem from a workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor
     * Remove problem from workshop
     */
    async removeProblemFromWorkshopRaw(requestParameters: RemoveProblemFromWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling removeProblemFromWorkshop().'
            );
        }

        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling removeProblemFromWorkshop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/problems/{problem_id}`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))).replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a problem from a workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor
     * Remove problem from workshop
     */
    async removeProblemFromWorkshop(requestParameters: RemoveProblemFromWorkshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeProblemFromWorkshopRaw(requestParameters, initOverrides);
    }

    /**
     * Reorder problems in a workshop.  Provide all problem IDs once each, in the desired order. The problem IDs must match the existing problems in the workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor
     * Reorder workshop problems
     */
    async reorderWorkshopProblemsRaw(requestParameters: ReorderWorkshopProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkshopProblemRead>>> {
        if (requestParameters['workshopId'] == null) {
            throw new runtime.RequiredError(
                'workshopId',
                'Required parameter "workshopId" was null or undefined when calling reorderWorkshopProblems().'
            );
        }

        if (requestParameters['workshopProblemReorder'] == null) {
            throw new runtime.RequiredError(
                'workshopProblemReorder',
                'Required parameter "workshopProblemReorder" was null or undefined when calling reorderWorkshopProblems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/workshops/{workshop_id}/problems/reorder`.replace(`{${"workshop_id"}}`, encodeURIComponent(String(requestParameters['workshopId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WorkshopProblemReorderToJSON(requestParameters['workshopProblemReorder']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkshopProblemReadFromJSON));
    }

    /**
     * Reorder problems in a workshop.  Provide all problem IDs once each, in the desired order. The problem IDs must match the existing problems in the workshop.  Requires authentication. User must be: - Organization administrator, OR - Workshop mentor
     * Reorder workshop problems
     */
    async reorderWorkshopProblems(requestParameters: ReorderWorkshopProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkshopProblemRead>> {
        const response = await this.reorderWorkshopProblemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
